<div class="evidence-pack-dialog-container">
  <div class="evidence-pack-dialog-header">
    <h2 mat-dialog-title class="evidence-pack-title">{{ 'Export evidence pack' | translate }}</h2>
    <button mat-icon-button mat-dialog-close class="close-button" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="evidence-pack-dialog-content">
    <p class="components-label">{{ 'Components to include' | translate }}</p>
    <div class="components-list">
      @for (component of components; track trackByIndex($index)) {
        <div class="component-row"
          [matTooltip]="component.disabled ? (component.disabledReason | translate) : ''"
          [matTooltipDisabled]="!component.disabled">
          <mat-checkbox [(ngModel)]="component.checked" [disabled]="component.disabled">
            {{ component.label | translate }}
          </mat-checkbox>
        </div>
      }
    </div>
  </div>

  <div mat-dialog-actions class="evidence-pack-dialog-actions">
    <button mat-stroked-button (click)="onCancel()" class="cancel-button" type="button">
      {{ 'Cancel' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="onExport()" class="export-button" type="button">
      <mat-icon>download</mat-icon>
      <span class="btn-text">{{ 'Export evidence pack' | translate }}</span>
    </button>
  </div>
</div>
